// utils/string-utils-server.js

/**
 * Generates a text excerpt (snippet) from a string, stripping HTML markup using regex.
 * Designed for use in Next.js Server Components.
 *
 * @param {string} htmlString - The input string, potentially containing HTML.
 * @param {number} maxLength - The maximum desired length of the excerpt (in characters).
 * @returns {string} The final excerpt string, truncated and optionally appended with an ellipsis.
 */
export const generateExcerptServerSide = (htmlString, maxLength) => {
   if (!htmlString || typeof htmlString !== 'string') {
      return '';
   }
   
   // 1. Strip HTML Markup using a Regular Expression
   // This regex matches anything between < and > (including the tags themselves).
   // Note: Regex stripping is fast but should be used with caution for very complex/malformed HTML.
   const rawText = htmlString.replace(/<[^>]*>/g, '');
   
   // 2. Normalize Whitespace
   // Replace all continuous whitespace (including newlines/tabs from stripping HTML) with a single space.
   const cleanText = rawText.replace(/\s+/g, ' ').trim();
   
   // 3. Truncate and Append Ellipsis
   if (cleanText.length <= maxLength) {
      // If the content is short enough, return it as is.
      return cleanText;
   }
   
   // Truncate the string to the maximum length
   let excerpt = cleanText.substring(0, maxLength);
   
   // Optional: Find the last space before the truncation point to avoid cutting a word.
   // This makes the snippet more readable.
   const lastSpace = excerpt.lastIndexOf(' ');
   if (lastSpace !== -1 && lastSpace > maxLength * 0.8) { // Only trim if close to the end
      excerpt = excerpt.substring(0, lastSpace);
   }
   
   // Append ellipsis
   return excerpt + '...';
};